import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const polarisProductGlobalFieldsSettingsEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-polaris-settings-global-fields", jiraSpaEntry: "async-polaris-ideas" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
